import { render, staticRenderFns } from "./wxChatGlobal.vue?vue&type=template&id=73854a41"
import script from "./wxChatGlobal.vue?vue&type=script&lang=js"
export * from "./wxChatGlobal.vue?vue&type=script&lang=js"
import style0 from "./wxChatGlobal.vue?vue&type=style&index=0&id=73854a41&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports